import React, { useEffect } from "react";
import {
  Container,
  Box,
  Grid,
  IconButton,
  Link,
  Hidden,
  Button,
  Typography,
  Paper,
  FormControl,
  Select,
  MenuItem,
} from "@mui/material";
// import useStyles from "./styles";
import { useFormContext } from "react-hook-form";

import { CardElement } from "@stripe/react-stripe-js";
import { useSharedBookReducer } from "../state";

const SurfGroupCount = (props) => {
  const [bookState, dispatch] = useSharedBookReducer();
  const { register, setValue } = useFormContext();

  const setGroupPeople = (e) => {
    setValue("grouppeople", e.target.value);
    setValue("people", e.target.value);
    dispatch({
      type: "MERGE",
      payload: {
        m: { people: e.target.value, grouppeople: e.target.value },
      },
    });
  };

  useEffect(() => {
    setValue("people", bookState.m.grouppeople);
  }, [bookState.m.grouppeople]);

  return (
    <>
      <input
        {...register("grouppeople", { shouldUnregister: true })}
        type="hidden"
        defaultValue={bookState.m.grouppeople}
      />
      <input
        {...register("people", { shouldUnregister: true })}
        type="hidden"
        defaultValue={bookState.m.grouppeople}
      />
      {/* <h3 class="title is-5">
									How many in your group?
								</h3>

								<div class="field is-horizontal" v-if="m.type == 'group'">
									<div class="field-body">
										<div class="control is-expanded has-icons-left">
											<div class="select is-fullwidth">
												<select name="people" v-model="m.grouppeople">
													<option value="2">2 people ()</option>
													<option value="3">3 people ()</option>
													<option value="4">4 people ()/person)</option>
												</select>
											</div>
											<span class="icon is-small is-left">
												<i class="fas fa-hashtag"></i>
											</span>
										</div>
									</div>
      </div>
       */}
      <Typography variant="h5">How many in your group?</Typography>
      {/* <input
        type="radio"
        name="grouppeople" // "people" ??
        value={bookState.m.grouppeople}
        style={{ display: "none" }}
      ></input> */}

      <FormControl sx={{ m: 1, minWidth: 120 }}>
        <Select value={bookState.m.grouppeople} onChange={setGroupPeople}>
          <MenuItem value="2">2 people</MenuItem>
          <MenuItem value="3">3 people</MenuItem>
          <MenuItem value="4">4 people</MenuItem>
        </Select>
      </FormControl>
    </>
  );
};

export default SurfGroupCount;
